import { Dispatch, SetStateAction, useEffect, useState } from "react";
import classNames from "classnames";
import { useWatch } from "react-hook-form";
import CommentBox from "../CommentBox";
import styles from "./index.module.scss";
import { Comment as CommentIcon, CommentText } from "../../Icons/chat";

type PropsType = {
  section?: string;
  id: string;
  hover: boolean;
  setHover: Dispatch<SetStateAction<boolean>>;
  commentBoxPosition?: "top" | "bottom";
  readOnly?: boolean;
  locked?: boolean;
};

const Comment = ({
  section,
  id,
  hover,
  setHover,
  commentBoxPosition,
  readOnly,
  locked
}: PropsType) => {
  const [open, setOpen] = useState(false);
  const idDotFormat = (() => {
    if (section) {
      return `comments.${section}.${id}`;
    }
    return `${id}`;
  })();

  useEffect(() => {
    if (open) {
      setHover(true);
    }
  });

  const commentExists = useWatch({ name: `${idDotFormat}.message` });
  const commentRead = useWatch({ name: `${idDotFormat}.read` });

  const text: string = (() => {
    if (commentRead) return "Read";
    if (commentExists) return "Commented";
    return "Comment";
  })();

  const customWidth = hover ? text.length * 15 + 35 : "40px"; // Dynamic width of button depending on length of text
  return (
    <div className={styles.wrapper}>
      <button
        disabled={readOnly}
        id={id}
        style={{ width: customWidth }}
        className={classNames(styles.button, {
          [styles.buttonActive]: open,
          [styles.divHover]: hover,
          [styles.read]: commentRead,
        })}
        type="button"
        onClick={() => {
          setOpen(!open);
        }}
      >
        {text}
        {commentExists ? <CommentText /> : <CommentIcon />}
      </button>
      <div
        className={classNames(styles.popup, {
          [styles.popupHide]: !open,
          [styles.popupTop]: commentBoxPosition === "top",
        })}
      >
        <CommentBox section={section} id={id} setOpen={setOpen} locked={locked}/>
      </div>
    </div>
  );
};

export default Comment;
